import React, { useEffect } from 'react'
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { sitesOptionsMap, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { array, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"

export default function UserSitesField() {

	const { sites, setSitesInfo } = useAdminUsersInfo(userPayload.peek()?.sites, "sites")

	const { errors, isValid } = useValidatorSeeker(
		{ sites: sites },
		object({
			sites: array().min(1, 'Must provide a site')
		})
	)

	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), sites: isValid }
	}, [isValid])

	return <AppSitesAutocomplete
		method="POST"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/sites`}
		onFinishAjax={options => {
			sitesOptionsMap.value = { ...sitesOptionsMap.value, ...Object.fromEntries(options.map(o => [String(o.value), o.label])) }
		}}
		value={sites}
		onChange={e => setSitesInfo(e.target.value)}
		error={errors?.sites}
	/>
}